import { axiosConfig } from './axios-config.js'

export const travel = {
  // 取得行程分類
  getCategory: (id, token) => axiosConfig.get(`/api/console/itinerary/category/${id}`, token),

  // 創建行程分類
  createCategory: (data, token) => axiosConfig.post('/api/console/itinerary/category', data, token),

  // 更新行程分類
  updateCategory: (id, data, token) => axiosConfig.patch(`/api/console/itinerary/category/${id}`, data, token),

  // 刪除行程分類
  deleteCategory: (id, token) => axiosConfig.delete(`/api/console/itinerary/category/${id}`, token),

  // 取得行程
  get: (id, token) => axiosConfig.get(`/api/console/itinerary/${id}`, token),

  // 創建行程
  create: (data, token) => axiosConfig.post('/api/console/itinerary', data, token),

  // 更新行程
  update: (id, data, token) => axiosConfig.patch(`/api/console/itinerary/${id}`, data, token),

  // 刪除行程
  delete: (id, token) => axiosConfig.delete(`/api/console/itinerary/${id}`, token)
}
